<script setup>
import {ref} from 'vue';
import {TransitionRoot} from '@headlessui/vue';
import {useI18n} from 'vue-i18n';
import FileView from '@/components/files/FileView.vue';

/**
 * Náhled souboru (PDF / obrázek) podle UUID ve stejném modalu jako „Náhled dokumentu“ (DocumentDetailModal).
 * Ve Shrnutí onboardingu ho používají dokumenty k emisi dluhopisů – patří dluhopisu, ne klientovi, takže je
 * DocumentDetailModal (dokumenty klienta podle ID) otevřít nemůže; dřív se otevíraly v novém okně a stahovaly.
 */
const props = defineProps({
  fileUuid: {type: String, required: true},
  // v onboardingu bez tlačítka Stáhnout, stejně jako náhled dokumentů klienta v onboardingu
  isNewOnboarding: {type: Boolean, default: false},
});
const emit = defineEmits(['confirm', 'cancel']);

const {t} = useI18n();
const isOpen = ref(true);

function close() {
  isOpen.value = false;
  setTimeout(() => emit('cancel'), 300);
}
</script>

<template>
  <TransitionRoot :show="isOpen" as="template">
    <div class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-xl" style="z-index: 1055">
        <div class="modal-content">
          <div class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <div class="modal-title">
                <h3>{{ t('documentDetailModal.preview_document') }}</h3>
              </div>
              <i class="btn-close cursor-pointer" @click="close" aria-label="Close"></i>
            </div>
            <div class="modal-body">
              <FileView :file="{uuid: props.fileUuid}" :is-new-onboarding="isNewOnboarding"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </TransitionRoot>
</template>
